module.exports = __webpack_public_path__ + "img/banner2.529b05a1.png";